<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat váhu služeb' | translate" route-name="serviceWeightCategoryNew" />
      <h1 v-translate>Váhy služeb</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="table_overflow">
        <table class="vypis vypis_detail">
        <thead>
        <tr v-if="entities.length > 0">
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"/>
          <sorting-table-title
              v-for="title in serviceWeightCategorysTableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit" />
        </tr>
        </thead>

        <service-weight-category-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            :selectedEntities="selectedEntities"
            @input="select"
            @deleteServiceWeightCategory="deleteEntity"
            :ref="'service-weight-category-row-ref-'+entity.id"
        />

        <tr v-if="entities.length === 0">
          <td colspan="5">{{ $gettext('Nebyly nalezeny žádné váhy služeb.') }}</td>
        </tr>
      </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import ServiceWeightCategoryRow from "@/components/views/serviceWeightCategories/ServiceWeightCategoryRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "ServiceWeightCategories",
  components: {
    ServiceWeightCategoryRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'serviceWeightCategories',
      entitiesKey: 'service_weight_categories',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
    }
  },
  created(ServiceWeightCategoryService) {
    this.entityService = ServiceWeightCategoryService

    this.createdInit()
  },
  computed: {
    serviceWeightCategorysTableTitles() {
      return this.$_readActionAllowedAllOrOwnAndGlobal ? this.ownerTableTitles : this.operatorTableTitles;
    },
    ownerTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Váha'), column: 'sValue'},
        {key: 3, name: this.$gettext('Počet služeb'), column: 'sServiceCount'},
        {key: 4, name: this.$gettext('Operátor'), column: 'sOperatorName'},
        {key: 5, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 6, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ];
    },
    operatorTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Váha'), column: 'sValue'},
        {key: 3, name: this.$gettext('Počet služeb'), column: 'sOperatorServiceCount'},
        {key: 4, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 5, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.serviceWeightCategorysTableTitles)
      if(this.$_readActionAllowedAllOrOwnAndGlobal) {
        headers.service_count.callback = entity => {
          return entity.services.length;
        };
      }else{
        headers.operator_service_count.callback = entity => {
          return entity.services.length;
        };
      }

      return headers;
    },
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
        if (message.match("^Unable to delete service weight category - there are (.*) services with given service weight category\.$")) {
          errorMessage = this.$gettext("Váhu služeb nelze smazat - existují služby s touto váhou.");
        } else {
          errorMessage = message;
        }
      }.bind(this))

      return errorMessage || error['error_message'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/serviceWeightCategories/ServiceWeightCategoriesList.vue